import _ from 'lodash';
import React, { useMemo } from 'react';
import {
  ProjectTaskFilter,
  ProjectTaskRecordStatusFilter,
  ProjectTaskStatusFilter,
  ProjectTaskTagFilter,
} from '~/components';

export default function TaskFiltersBar({ filters, sticky, onChange }) {
  const visible = useMemo(() => {
    const isVisible = (key) => sticky?.includes(key) || !_.isEmpty(filters[key]);
    return {
      projectTasks: isVisible('projectTasks'),
      projectTaskStatuses: isVisible('projectTaskStatuses'),
      projectTaskRecordStatusId: isVisible('projectTaskRecordStatusId'),
      projectTaskTags: isVisible('projectTaskTags'),
    };
  }, [filters, sticky]);

  return (
    <>
      {visible.projectTasks && (
        <ProjectTaskFilter
          project={filters.projects[0]}
          value={filters.projectTasks}
          onChange={({ value }) => onChange({ projectTasks: value })}
        />
      )}

      {visible.projectTaskStatuses && (
        <ProjectTaskStatusFilter
          value={filters.projectTaskStatuses}
          onChange={({ value }) => onChange({ projectTaskStatuses: value })}
        />
      )}

      {visible.projectTaskRecordStatusId && (
        <ProjectTaskRecordStatusFilter
          value={filters.projectTaskRecordStatusId}
          onChange={({ value }) => onChange({ projectTaskRecordStatusId: value })}
        />
      )}

      {visible.projectTaskTags && (
        <ProjectTaskTagFilter
          value={filters.projectTaskTags}
          onChange={({ value }) => onChange({ projectTaskTags: value })}
        />
      )}
    </>
  );
}
